import React from "react";
import { Link } from "react-router-dom";
import cookie from "react-cookies";
import { connect } from "react-redux";

import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper";

import { setCookiesRoutes } from "../common/wdfunction";

import { stypes, moment } from "../common/common";


const AirportItem = ({ dest, sd }) => {

	const locCity = Buffer.from(`${dest.lat.toString()}-${dest.lon.toString()}`).toString('base64')
	let durationTimeArr = [0, 4, 6, 8, 10, 12, 16, 24, 36, 48, 60];
	const selectHour = durationTimeArr[1];
	const findCar = (sd) => {
		// format wdLocations

		
	

		if (sd) {
			window.history.pushState({ prevUrl: window.location.href }, null, `/find/filter?loc=${locCity}&address=${dest.name}&deliveryId=${dest.id}&isAirDelivery=${true}`)
			window.location.reload()
		} else {
			const wdLocations = `${dest.lat}-${dest.lon}-${Buffer.from(dest.name).toString("base64")}`;

			setCookiesRoutes({
				isCityTourMode: true,
				wdOneWay: false,
				wdDistance: 0,
				wdDistanceOW: 0,
				wdDistanceBackOW: 0,
				wdLocations,
			});
			
			window.history.pushState({ prevUrl: window.location.href }, null, `/withdriver/find/filter?address=${dest.name}&deliveryId=${dest.id}&isAirDelivery=${true}&isCityTourMode=${true}&isOneWay=${false}&selectHour=${selectHour}`)
			window.location.reload()
		}

	
	};

	return (
		<>
			{sd ? (
				// <Link
				// 	to={{
				// 		pathname: `/find/filter`,
				// 		search: `loc=${locCity}&address=${dest.name}&deliveryId=${dest.id}&isAirDelivery=${true}`,
				// 	}}>
				// <Link />
				<a onClick={findCar}>
					<div className="airport-item">
						<div className="fix-img">
							<img loading="lazy" src={dest.cover} alt={`Cho thuê xe tự lái ${dest.name}`} />
						</div>
						<p>{dest.name} </p>
						<span>{dest.totalCars} xe</span>
					</div>
				</a>
			
			) : (
				// <Link
				// 	to={{
				// 		pathname: `/withdriver/find/filter`,
				// 		search: `address=${dest.name}&deliveryId=${
				// 			dest.id
				// 		}&isAirDelivery=${true}&isCityTourMode=${true}&isOneWay=${false}&selectHour=${selectHour}`,
				// 	}}
				// 	onClick={findCar}>
				// </Link>
				<a onClick={findCar}>
					<div className="airport-item">
						<div className="fix-img">
							<img loading="lazy" src={dest.cover} alt={`Cho thuê xe du lịch ${dest.name}`} />
						</div>
						<p>{dest.name}</p>
						<span>{dest.totalCars} xe</span>
					</div>
				</a>
			)}
		</>
	);
};

const AirportDelivery = (props) => {
	const { stype, airDelivery } = props;
	const isSD = stype === stypes.SD;

	return (
		<div className="m-container airport">
			{isSD ? (
				<h4 className="airport-head">Giao&nbsp;xe&nbsp;tại sân&nbsp;bay</h4>
			) : (
				<h4 className="airport-head">Đưa&nbsp;đón&nbsp;tại sân&nbsp;bay</h4>
			)}
			<Swiper
				className="swiper-topdes-airport"
				spaceBetween={10}
				slidesPerView={1.4}
				modules={[Navigation, Pagination]}
				pagination={{
					el: ".pagi-topdes-airport",
					clickable: true,
					dynamicBullets: true,
				}}
				navigation={{
					nextEl: ".topdes-airport-next",
					prevEl: ".topdes-airport-prev",
				}}
				breakpoints={{
					992: {
						slidesPerView: isSD ? 4 : 3,
						spaceBetween: 20,
					},
					768: {
						slidesPerView: 2.5,
						spaceBetween: 10,
					},
					481: {
						slidesPerView: 2,
					},
				}}>
				{airDelivery.map((dest) => (
					<SwiperSlide key={dest.id}>
						<AirportItem
							dest={dest}
							sd={isSD}
							startDate={props.appInit.data.startTime}
							endDate={props.appInit.data.endTime}
						/>
					</SwiperSlide>
				))}
				<div className="swiper-pagination pagi-topdes-airport" />
			</Swiper>
			<div className={`swiper-button-prev topdes-airport-prev`} />
			<div className={`swiper-button-next topdes-airport-next`} />
		</div>
	);
};

function mapState(state) {
	return {
		appInit: state.appInit,
	};
}

export default connect(mapState)(AirportDelivery);
